// src/components/Market/OctaFXMT5WebTerminal.jsx
import React from "react";

export default function OctaFXMT5WebTerminal() {
  // Add all known server names you want to appear in the dropdown:
  const url =
    "https://trade.mql5.com/trade?servers=OctaFX-Real,OctaFX-Real 2,OctaFX-Demo&lang=en&platform=MetaTrader5";
  return (
    <iframe
      src={url}
      title="OctaFX MT5 Web Terminal"
      width="100%"
      height="600px"
      style={{ border: 0, borderRadius: 8, minHeight: 400 }}
      allowFullScreen
    />
  );
}


